import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface LeadScoreBadgeProps {
  score: number;
  size?: 'sm' | 'lg';
}

function getScoreColor(score: number): string {
  if (score >= 75) return 'bg-green-500/15 text-green-700 dark:text-green-300 border-green-500/30';
  if (score >= 50) return 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30';
  if (score >= 25) return 'bg-orange-500/15 text-orange-700 dark:text-orange-300 border-orange-500/30';
  return 'bg-destructive/15 text-destructive border-destructive/30';
}

export default function LeadScoreBadge({ score, size = 'sm' }: LeadScoreBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(
        getScoreColor(score),
        size === 'lg' ? 'px-3 py-1 text-sm' : 'text-[10px]'
      )}
    >
      {score}
    </Badge>
  );
}
